import React from "react";
import ContentLoader from "react-content-loader";

const SearchResultLoader = () => (
  <ContentLoader
    speed={2}
    width={680}
    height={400}
    viewBox="0 0 660 400"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    style={{ maxWidth: "100%" }}
  >
    <rect x="0" y="6" rx="2" ry="2" width="199" height="18" />
    <rect x="0" y="34" rx="2" ry="2" width="140" height="10" />
    <rect x="0" y="56" rx="2" ry="2" width="660" height="162" />
    <rect x="0" y="232" rx="0" ry="0" width="660" height="10" />
    <rect x="0" y="255" rx="0" ry="0" width="660" height="10" />
    <rect x="0" y="277" rx="0" ry="0" width="660" height="10" />
    <rect x="0" y="315" rx="2" ry="2" width="133" height="35" />
    <rect x="152" y="315" rx="2" ry="2" width="133" height="35" />
  </ContentLoader>
);

export default SearchResultLoader;
